<div style="height: calc(100vh - 92px - 20px - 40px);">

  <div class="group-list-button-row">

    <span class="group-list-button" title="Create a new group">
      <p-splitButton label="Create Group" icon="fa fa-plus-square-o"
      [model]="createMenuItems" appendTo="body"></p-splitButton>
    </span>

    @if (syncMenuItems.length > 0) {
      <span class="group-list-button" title="Sync directory group data">
        <p-splitButton label="Sync" icon="fa fa-refresh"
        [model]="syncMenuItems" appendTo="body"></p-splitButton>
      </span>
    }

  </div>

  <p-table #dt [value]="entries" [resizableColumns]="true"
    [scrollable]="true" scrollHeight="calc(100vh - 92px - 20px - 48px - 60px - 40px + 6px)">

    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn pSortableColumn="groupname">
          Name
          <p-sortIcon field="groupname"></p-sortIcon>
        </th>
        <th pResizableColumn pSortableColumn="class">
          Class
          <p-sortIcon field="class"></p-sortIcon>
        </th>
        <th pResizableColumn pSortableColumn="type">
          Type
          <p-sortIcon field="type"></p-sortIcon>
        </th>
        <th pResizableColumn pSortableColumn="active">
          Active
          <p-sortIcon field="active"></p-sortIcon>
        </th>
        <th class="uv-table-button-column-2">
        </th>
      </tr>

      <tr>
        <th>
          <input pInputText type="text" (input)="dt.filter($event.target.value, 'groupname', 'contains')"
            style="width: 100%;">
          </th>
          <th>
            <input pInputText type="text" (input)="dt.filter($event.target.value, 'class', 'contains')"
              style="width: 100%;">
            </th>
            <th>
              <input pInputText type="text" (input)="dt.filter($event.target.value, 'type', 'contains')"
                style="width: 100%;">
              </th>
              <th>
                <input pInputText type="text" (input)="dt.filter($event.target.value, 'active', 'contains')"
                  style="width: 100%;">
                </th>
                <th class="uv-table-button-column-2">
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              <tr [pSelectableRow]="rowData">
                <td>
                  <span class="uv-table-value">{{rowData.groupname}}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{rowData.class}}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{rowData.type}}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{rowData.active}}</span>
                </td>
                <td class="uv-table-button-column-2">
                  <button [disabled]="!isLicenseValid" class="btn btn-primary uv-first-table-button"
                    title="Edit this group" (click)="editGroup(rowData.tag)">
                    <i class="fa fa-edit"></i>
                  </button>

                  <button [disabled]="!isLicenseValid" class="btn btn-danger uv-table-button"
                    title="Delete this group" (click)="deleteGroup(rowData.tag)">
                    <i class="pi pi-trash"></i>
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <group-dialog [(visible)]="groupDialogVisible" [target]="groupDialogTarget" [create]="groupDialogCreate"
            (onOk)="onGroupDialogOkClicked($event)" (onCancel)="onGroupDialogCancelClicked()">
          </group-dialog>

          <confirmation-dialog message="Are you sure you want to delete this group?"
            [display]="confirmDeleteDialogVisible"
            (onYes)="onDeleteConfirmDialogOkClicked()" (onNo)="onDeleteConfirmDialogCancelClicked()">
          </confirmation-dialog>

          <ad-admin-dialog [(display)]="adAdminDialogVisible" messageType="group" [domains]="adAdminDialogDomains"
            (onOk)="onAdAdminDialogOkClicked($event)" (onCancel)="onAdAdminDialogCancelClicked()">
          </ad-admin-dialog>

          <google-admin-dialog [(display)]="gwAdminDialogVisible" messageType="group"
            (onOk)="onGwAdminDialogOkClicked()" (onCancel)="onGwAdminDialogCancelClicked()">
          </google-admin-dialog>

          <directory-group-dialog [(visible)]="dirGroupDialogVisible" [target]="dirGroupTarget"
            [create]="isDirGroupCreate" [groupType]="dirGroupAccountType" [domains]="dirGroupDialogDomains"
            (onOk)="onDirGroupDialogOkClicked($event)" (onCancel)="onDirGroupDialogCancelClicked()">
          </directory-group-dialog>

        </div>
